module.exports = __webpack_public_path__ + "static/img/icon_home_frist_content.93e1186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_home_frist_content.png
// module id = EqF3
// module chunks = 1